/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {LegacyGetMerchantRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {GetMerchantResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const legacyGetMerchant = (request: LegacyGetMerchantRequest, options?: CashRequestOptions) => post<LegacyGetMerchantRequest, GetMerchantResponse>("/2.0/cash/legacy-get-merchant", request, {...options, rejectOnError: true })